'use client'
import {useParams} from "next/navigation";

export const useInstitutionContext = () => {
    const params = useParams();
    const institutionId = params.institution;
    if(typeof institutionId !== "string") throw new Error("useInstitutionContext was called in a non-valid context (maybe outside of a institution page)");

    return institutionId;
}
